<template>
  <div class="home-game-wrapper">

    <CategorySection
  v-if="selectedCategory === 'lobby' || selectedCategory === 'rivo-originals'"
  :category="rivoOriginals"
  :favorites="favorites"
  :onToggleFavorite="toggleFavorite"
  :loading="false"
  :isRivoOriginals="true"  
  key="rivo"
/>

  <!-- HOT CATEGORY -->
<!-- HOT CATEGORY -->
<CategorySection
  v-if="selectedCategory === 'lobby' || selectedCategory === 'hot'"
  :category="hotCategory"
  :favorites="favorites"
  :onToggleFavorite="toggleFavorite"
  :loading="loading"
  key="hot"
/>

<!-- FAVORITES -->
<CategorySection
  v-if="(selectedCategory === 'favorites' && favoriteGames.length > 0) || (selectedCategory === 'lobby' && favoriteGames.length > 0)"
  :category="favoriteCategoryWithUniqueKeys"
  :favorites="favorites"
  :onToggleFavorite="toggleFavorite"
  :loading="false"
  key="favorites"
/>




 

<!-- API CATEGORIES -->
<CategorySection
  v-for="category in visibleCategories"
  :key="'cat-' + category._id"
  :category="category"
  :favorites="favorites"
  :onToggleFavorite="toggleFavorite"
  :loading="loading"
/>


  </div>
</template>

<script>
import axios from 'axios';
import CategorySection from '@/components/home/CategorySection.vue';

export default {
  name: 'HomeGame',
  components: {
    CategorySection
  },
  props: {
    selectedCategory: {
      type: String,
      default: 'lobby'
    }
  },
  data() {
    return {
      categories: [],
      favorites: [],
      favoriteGames: [],
      loading: true,
      hotCategory: {
        name: 'Hot',
        img: '/public/img/hot.svg',
        slug: 'hot',
        total_games: 0,
        games: []
      },
      favoriteCategory: {
        name: 'Favorites',
        img: '/public/img/star.svg',
        slug: 'favorites',
        total_games: 0,
        games: []
      },
      rivoOriginals: {
        name: 'Rivo Originals',
        img: '/public/img/rivoor.svg',
        slug: 'rivo-originals',
        total_games: 6,
        games: [
          { _id: "rivo1", game_name: "Rivo Turbo", banner: "/public/img/games/1.png", views: 1234, provider: { name: "RivoBIT" }, slug: "turbo" },
          { _id: "rivo8", game_name: "Rivo Witch X", banner: "/public/img/games/2.png", views: 432, provider: { name: "RivoBIT" }, route: "Crash" },
          { _id: "rivo2", game_name: "Rivo Wingo", banner: "/public/img/games/3.png", views: 867, provider: { name: "RivoBIT" }, slug: "Wingo" },
          { _id: "rivo3", game_name: "Rivo Unbox", banner: "/public/img/games/4.png", views: 432, provider: { name: "RivoBIT" }, slug: "unbox" },
          { _id: "rivo4", game_name: "Rivo Mines", banner: "/public/img/games/5.png", views: 432, provider: { name: "RivoBIT" }, slug: "mines" },
          { _id: "rivo7", game_name: "Rivo Blackjack", banner: "/public/img/games/8.png", views: 432, provider: { name: "RivoBIT" }, slug: "Blackjack" },
           { _id: "rivo6", game_name: "Rivo Roll", banner: "/public/img/games/7.png", views: 432, provider: { name: "RivoBIT" }, slug: "roll" },
          { _id: "rivo5", game_name: "Rivo Towers", banner: "/public/img/games/6.png", views: 432, provider: { name: "RivoBIT" }, slug: "towers" },
          
           
       
 
        ]
      }
    };
  },
 computed: {
  favoriteCategoryWithUniqueKeys() {
    // ID'yi değiştirme, sadece key için ayrı kullan
    const seen = new Set();
    const uniqueGames = this.favoriteGames.filter(game => {
      if (seen.has(game._id)) return false;
      seen.add(game._id);
      return true;
    });

    return {
      ...this.favoriteCategory,
      games: uniqueGames
    };
  },
   visibleCategories() {
    if (!this.categories) return [];
    // Lobby seçiliyse tüm kategorileri göster
    if (this.selectedCategory === 'lobby') return this.categories;

    // Değilse sadece eşleşeni göster
    return this.categories.filter(c => c.slug === this.selectedCategory);
  }
},

  methods: {
    toggleFavorite(gameId) {
      const exists = this.favorites.includes(gameId);
      const updated = exists
        ? this.favorites.filter(id => id !== gameId)
        : [...this.favorites, gameId];

      this.favorites = updated;
      localStorage.setItem('gameFavorites', JSON.stringify(updated));
      this.updateFavoriteGames();
    },
    updateFavoriteGames() {
      const allGames = [
  ...this.hotCategory.games,
  ...this.rivoOriginals.games,
  ...this.categories.flatMap(c => c.games)
];

// Favori oyunları benzersiz hale getir
const favMap = {};
allGames.forEach(game => {
  if (this.favorites.includes(game._id)) {
    favMap[game._id] = game;
  }
});
const favGames = Object.values(favMap);

this.favoriteGames = favGames;
this.favoriteCategory.games = favGames;
this.favoriteCategory.total_games = favGames.length;
    },
    getCategoryGames(category) {
  return category.games.filter(game => !this.favorites.includes(game._id));
}

  },
  
  created() {
    const savedFavorites = JSON.parse(localStorage.getItem('gameFavorites') || '[]');
    this.favorites = savedFavorites;

    axios.get('/public/games/featured/list?limit=50')
      .then(res => {
        this.hotCategory.games = res.data || [];
        this.hotCategory.total_games = this.hotCategory.games.length;
      })
      .catch(() => {
        this.hotCategory.games = [];
      });

    axios.get('/public/games/categories/with-games')
      .then(res => {
        this.categories = res.data.data || [];
      })
      .catch(() => {
        this.categories = [];
      })
      .finally(() => {
        this.loading = false;
        this.updateFavoriteGames();
      });
  }
};
</script>

<style scoped>
.home-game-wrapper {
  padding: 20px 0px;
}
</style>
